import "@total-typescript/ts-reset";
import { setSentry } from "@mozioinc/logging";
import { captureException } from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { getEnvs } from "./utils/env";
import { setGoogleConsent } from "./utils/google-consent";
import { setMocks } from "./utils/mock";
import { setOsano } from "./utils/osano";
import { reconcileSessionIdentity } from "./utils/session-identity";
import { setTranslation } from "./utils/translation";
import "@mozioinc/ui/src/index.css";
import { setWhiteLabel } from "./utils/white-label";
import { setZendesk } from "./utils/zendesk";

const {
  GIT_COMMIT_SHA,
  DEPLOY_ENV,
  API_ENV,
  QUERY_ENV,
  MOZIO_PUBLIC_SENTRY_DSN,
  MOZIO_PUBLIC_SENTRY_ORGANIZATION,
  MOZIO_PUBLIC_SENTRY_PROJECT_ID,
} = getEnvs();

window.APP_VERSION = APP_VERSION;
window.GIT_COMMIT_SHA = GIT_COMMIT_SHA;
console.info("App version:", APP_VERSION);
console.info("Deploy env:", { DEPLOY_ENV, API_ENV, QUERY_ENV });

setSentry({
  env: DEPLOY_ENV,
  version: APP_VERSION,
  dsn: MOZIO_PUBLIC_SENTRY_DSN,
  organization: MOZIO_PUBLIC_SENTRY_ORGANIZATION,
  projectId: MOZIO_PUBLIC_SENTRY_PROJECT_ID,
});

Promise.resolve()
  .then(setWhiteLabel)
  .then(setMocks)
  .then(setTranslation)
  .then(setGoogleConsent)
  .then(setOsano)
  .then(setZendesk)
  .then(reconcileSessionIdentity)
  .then(() =>
    createRoot(document.querySelector("#root")!).render(
      <StrictMode>
        <App />
      </StrictMode>,
    ),
  )
  .catch((error: Error) => {
    console.error(error);
    // TODO: Implement error tracking and error view
    captureException(error);
    createRoot(document.querySelector("#root")!).render(
      <StrictMode>Oops something went wrong!</StrictMode>,
    );
  });
